import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function ProblemSection() {
  return <SectionWrapper data-id="element-134">
      <div className="max-w-3xl mx-auto text-center" data-id="element-135">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-brown mb-8" data-id="element-136">
          El problema no es tu edad. <br data-id="element-137" />
          <span className="text-brand-terracotta" data-id="element-138">
            El problema es la inflamación.
          </span>
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-brand-brown/80 font-sans text-left" data-id="element-139">
          <p data-id="element-140">
            La mayoría de las mujeres latinas en Estados Unidos creen que
            "aguantar" estos síntomas es parte de la edad. Te han dicho que es
            normal estar agotada, que la grasa abdominal es inevitable después
            de los 40 y que la única solución es resignarte o llenar tu cuerpo
            de hormonas sintéticas.
          </p>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-brand-surface mt-8" data-id="element-141">
            <p className="font-semibold text-brand-brown" data-id="element-142">
              El problema no es tu edad. El problema es que el sistema
              alimentario en este país —lleno de aceites vegetales
              inflamatorios, azúcares ocultos y trigos modificados— actúa como
              gasolina sobre el fuego de tus cambios hormonales.
            </p>
            <p className="mt-4 text-brand-terracotta font-bold text-xl text-center" data-id="element-143">
              Tu cuerpo no está roto; está inflamado.
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}